<template>
  <div class="quickReply">
    <div class="quickReplyBox">
      <el-button type="success" @click="onAdd()" :disabled="editIndex !== null">
        添加快捷回复
      </el-button>

      <ul class="listBox">
        <li v-for="(reply, i) in quickReplyData" :key="i">
          <el-card shadow="never">
            <el-row type="flex" :gutter="20" align="middle" v-show="editIndex == i">
              <el-col :span="2">
              <span>
                <el-input v-model="quickReplyData[i].serialNumber" :placeholder="i + 1"></el-input>
              </span>
              </el-col>
              <el-col :span="20">
                <el-input v-model="quickReplyData[i].content" placeholder="快捷回复" maxlength="30" show-word-limit></el-input>
              </el-col>

              <el-col :span="2">
                <i class="el-icon-success" @click="onSave(i, reply)" style="margin-right: 6px"></i>
                <i class="el-icon-delete" @click="onDelete(i, reply.id)"></i>
              </el-col>
            </el-row>
            <el-row type="flex" :gutter="20" align="middle" v-show="editIndex != i">
              <el-col :span="2">
              <span>
                {{ reply.serialNumber }}
              </span>
              </el-col>
              <el-col :span="20">
                {{ reply.content }}
              </el-col>

              <el-col :span="2">
                <i class="el-icon-edit-outline" @click="onSetting(i)" style="margin-right: 6px"></i>
                <i class="el-icon-delete" @click="onDelete(i, reply.id)"></i>
              </el-col>
            </el-row>
          </el-card>
        </li>
      </ul>
      <!--<footer>
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="currentChange"
          :current-page="tableConfig.current"
          :total="total"
        ></el-pagination>
      </footer>-->
    </div>

  </div>
</template>
<script>
import md5 from "md5";
import _ from "lodash";

export default {
  name: "QuickReply",
  data() {
    return {
      editIndex: null,
      quickReplyData: [],
      total: 10, // 总数量
      tableConfig: {
        current: 1, // 当前页码
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await axios.post(vmsReqUrl+"/quickReply/list", {current: 1});
      res = res.data;
      if (res.code === 200) {
        this.quickReplyData = res.data.records
        this.total = res.data.total
        console.log('res.data', res.data)
      }
    },

    onSetting(i) {
      this.editIndex = i
    },

    async onDelete(i, id) {
      this.$confirm("确认删除吗？", "提示",{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async() => {
          if (id) {
            let res = await axios.delete(vmsReqUrl+"/quickReply/delete/" + id);
            res = res.data
            if (res.code === 200) {
              this.editIndex = null
              await this.getData()
              this.$message.success(res.message)
            } else {
              // this.$message.warning(res.message)
            }
          }
          else {
            this.quickReplyData.shift();
            this.editIndex = null
          }

        })
        .catch(_ => {})
    },

    onAdd() {
      if (this.editIndex) {
        this.$message.warning('请先完成编辑')
        return false
      } else {
        const serialNumber = this.quickReplyData.length ? (this.quickReplyData[0].serialNumber + 1) : 1
        this.quickReplyData.unshift({
          serialNumber: serialNumber,
          content: '快捷回复',
        })
        this.editIndex = 0
      }
    },

    async onSave(i, reply) {
      let res = await axios.post(vmsReqUrl+"/quickReply/save", {
        content: reply.content,
        id: reply.id || 0,
        serialNumber: reply.serialNumber
      });
      res = res.data;
      if (res.code === 200) {
        await this.getData()
        this.editIndex = null
      }
    },

    currentChange(index) {
      // 分页
      this.tableConfig.current = index;
      this.getData();
      this.editIndex = null
    },
  }
};
</script>
<style lang="sass" scoped>
.quickReply
  min-width: 800px
  .quickReplyBox
    padding: 20px
    width: 80%
    .listBox
      list-style: none
      margin: 0
      padding: 0
      li
        margin-top: 20px
        font-size: 14px
  footer
    padding-top: 20px
    text-align: center



</style>



// WEBPACK FOOTER //
// src/vms/pages/views/quickReply.vue